import { supabase } from '../supabase/client';
import { filterSichtbareRechnungen } from '../rechnungen/sichtbarkeit';

export interface SichtRechnung {
  id: string; rechnungsnummer: string | null; unternehmen: string | null;
  brutto: number | null; status: string | null; faelligkeitsdatum: string | null;
  created_at: string; zustaendig_id: string | null; zustaendig_typ: string | null; objekt_id: string | null;
  tech_pruefung_an: string | null; freigabe_angefordert_an: string | null;
  objekte: { objekttyp?: string } | null;
}

// `rechnungen` hat alle Sichtbarkeits-Spalten. `rechnungen_unklar` (KI-Pool) hat KEINE
// tech_pruefung_an/freigabe_angefordert_an-Spalten (per MCP-Spaltencheck geprüft) — daher
// eigenes, kürzeres Select für den Pool + Nullmapping (der Filter behandelt null korrekt).
// zustaendig_typ ist in beiden Tabellen vorhanden (Zuständigkeits-Projekt, per MCP geprüft).
const FELDER_RECHNUNGEN = 'id, rechnungsnummer, unternehmen, brutto, status, faelligkeitsdatum, created_at, zustaendig_id, zustaendig_typ, objekt_id, tech_pruefung_an, freigabe_angefordert_an, objekte:objekt_id(objekttyp)';
const FELDER_UNKLAR = 'id, rechnungsnummer, unternehmen, brutto, status, faelligkeitsdatum, created_at, zustaendig_id, zustaendig_typ, objekt_id, objekte:objekt_id(objekttyp)';

/** Nicht archivierte Belege, gefiltert wie die Rechnungsliste (personen-/team-orientiert). */
export async function ladeSichtbareRechnungen(userProfile: any): Promise<{ rechnungen: SichtRechnung[]; unklar: SichtRechnung[] }> {
  const nutzer = {
    id: userProfile?.id || '',
    role: userProfile?.role,
    rechnungen_bereich: userProfile?.rechnungen_bereich,
    team_member_ids: userProfile?.team_member_ids,
    team_ids: userProfile?.team_ids,
    sieht_alle_rechnungen: userProfile?.sieht_alle_rechnungen,
  };
  const [r1, r2] = await Promise.all([
    supabase.from('rechnungen').select(FELDER_RECHNUNGEN).is('archiviert_am', null),
    supabase.from('rechnungen_unklar').select(FELDER_UNKLAR).is('archiviert_am', null),
  ]);
  const unklarGemappt = ((r2.data || []) as any[]).map(r => ({
    ...r,
    tech_pruefung_an: null,
    freigabe_angefordert_an: null,
    is_unklar_source: true,
  }));
  return {
    rechnungen: filterSichtbareRechnungen(((r1.data || []) as any[]), nutzer) as SichtRechnung[],
    unklar: filterSichtbareRechnungen(unklarGemappt, nutzer) as SichtRechnung[],
  };
}
